document.addEventListener('DOMContentLoaded', function() {
  const body = document.querySelector('body');
  const header = document.querySelector('.header-wrapper');
  const mobileMenuButton = document.querySelector('.header__icon--menu');
  
  function updateHeaderState() {
    const isMenuOpen = document.body.classList.contains('overflow-hidden') || 
                       header.querySelectorAll('details[open]').length > 0;
    
    if (isMenuOpen) {
      body.classList.add('menu-open-no-shrink');
      body.classList.remove('scrolled-past-header');
    } else {
      body.classList.remove('menu-open-no-shrink');
      body.classList.toggle('scrolled-past-header', window.scrollY > 10);
    }
  }
  
  const observer = new MutationObserver(updateHeaderState);
  header.querySelectorAll('details').forEach(details => {
    observer.observe(details, { attributes: true });
  });
  
  if (mobileMenuButton) {
    mobileMenuButton.addEventListener('click', () => setTimeout(updateHeaderState, 50));
  }
  document.addEventListener('click', () => setTimeout(updateHeaderState, 50));
  window.addEventListener('scroll', updateHeaderState);
  
  updateHeaderState();
});